import React, { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import SingleHomeReviews from "../SingleHomeReviews/SingleHomeReviews";
import "./HomeReviews.css";

const HomeReviews = () => {
  const [homeReviews, setHomeReviews] = useState([]);
  let settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  useEffect(() => {
    fetch("https://watch-club-server-samiul-ahmed-96.koyeb.app/reviews")
      .then((res) => res.json())
      .then((data) => setHomeReviews(data));
  }, []);
  return (
    <Container id="homeReviews" className="reviews-container overflow-hidden">
      <div className="second-heading text-center">
        <h2>Explore Our Reviews</h2>
        <h3>
          What Our Client
          <span>Say</span>
        </h3>
      </div>
      <Row className="gx-5 gy-5 p-5">
        <Slider {...settings}>
          {homeReviews.map((review) => (
            <SingleHomeReviews
              key={review._id}
              review={review}
            ></SingleHomeReviews>
          ))}
        </Slider>
      </Row>
    </Container>
  );
};

export default HomeReviews;
